import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core'
import { SidebarService } from '../../services/sidebar.service'
import { NavigationEnd, Router, RouterLink } from '@angular/router'
import { AuthService } from '@auth/services/auth.service'
import { UserService } from '@participant/services/user.service'
import { ClicksDirective } from '@shared/directives/clicks.directive'

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterLink, ClicksDirective],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidebarComponent {
  sidebarService = inject(SidebarService)
  userService = inject(UserService)
  authService = inject(AuthService)
  router = inject(Router)

  sidebar = this.sidebarService.sidebar
  user = computed(() => this.userService.user())

  navList = [
    {
      image: 'https://res.cloudinary.com/superlikers/image/upload/v1768861754/HOME_cfoy6h.svg',
      name: 'Home',
      redirect: '/',
      show: () => true
    },
    {
      image: 'https://res.cloudinary.com/superlikers/image/upload/v1768861754/PERFIL_mldpyh.svg',
      name: 'Mi Perfil',
      redirect: '/participant/profile',
      show: () => true
    },
    {
      image: 'https://res.cloudinary.com/superlikers/image/upload/v1768861753/SOCIOS_haautn.svg',
      name: 'Socios comerciales',
      redirect: '/socios_comerciales',
      show: () => true
    },
    {
      image: 'https://res.cloudinary.com/superlikers/image/upload/v1768861755/REFERIDOS_ghmbgx.svg',
      name: 'Referidos',
      redirect: '/referral',
      show: () => true
    },
    {
      image: 'https://res.cloudinary.com/superlikers/image/upload/v1768861753/MODELORAMA_ESCUELA_njqpbq.svg',
      name: 'Modelorama Escuela',
      redirect: '/modelorama',
      show: () => true
    },
    {
      image: 'https://res.cloudinary.com/superlikers/image/upload/v1768861753/SOCIOS_haautn.svg',
      name: 'Hoja Única',
      redirect: '/hoja-unica',
      show: () => this.user()?.super === 'ok'
    },
    {
      image: 'https://res.cloudinary.com/superlikers/image/upload/v1768861755/PREGUNTAS_FRECUENTES_c8hevg.svg',
      name: 'Preguntas frecuentes',
      redirect: '/preguntas_frecuentes',
      show: () => true
    },
    {
      image: 'https://res.cloudinary.com/superlikers/image/upload/v1768861753/SOCIOS_haautn.svg',
      name: 'Términos y condiciones',
      redirect: '/tos',
      show: () => true
    }
  ]

  constructor() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.hideSidebar()
      }
    })
  }

  hideSidebar(event?: MouseEvent | KeyboardEvent) {
    if (event && event.target !== event.currentTarget) return
    this.sidebarService.changeSidebar(false)
  }

  async logout() {
    const response = await this.authService.logout()
    if (response.state === 'success') {
      this.router.navigateByUrl('/login')
    }
  }
}
